import axios from 'config/axios'

const TicketServices = {
  getUnreadSummary: async () => {
    const { data } = await axios.get('tickets/unread-summary')
    return data
  },
  getTickets: async (params) => {
    const { data } = await axios.get('tickets', { params })
    return data
  },
  createTicket: async (formData) => {
    const { data } = await axios.post('tickets', formData)
    return data
  },
  getTicketDetail: async (id) => {
    const { data } = await axios.get(`tickets/${id}`)
    return data
  },
  replyTicket: async (id, formData) => {
    const { data } = await axios.post(`tickets/${id}/reply`, formData)
    return data
  }
}

export default TicketServices
